import { Component, Injector, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { LookUpResourceModel } from 'src/app/section-wise/models/lookup-resource.model';
import { BaseSWQuestion } from '../../../extended-class/base-ws-question';

@Component({
  selector: 'insurance-company',
  templateUrl: './insurance-company.component.html',
  host: { class: 'insurance-company' }
})
export class InsuranceCompanyComponent extends BaseSWQuestion implements OnInit {
  question: LookUpResourceModel;

  constructor(serviceInjector: Injector) {
    super(serviceInjector);
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((param: any) => {
      this.question = JSON.parse(param['question']);
    });
    this.swProcessStateService.swContractType$.pipe(take(1)).subscribe((contractType) => {
      this.contractType = JSON.parse(JSON.stringify(contractType));
    });
  }

  saveSectionAnswer() {
    this.swProcessStateService.updateSwProcessModel(this.contractType);
    this.addGTMAnswer(this.question.QuestionNumber, this.contractType.otherHealthInsurance + '');
    this.sectionWiseService.closeSwqModal(this.question);
  }

  isOtherHealthInsurance(value: number) {
    return value === 1 && this.contractType.otherHealthInsurance ? true : false;
  }

  selectOtherHealthInsurance(value: number) {
    this.contractType.otherHealthInsurance = value === 1;
  }
}
